export default "__VITE_ASSET__f59jUNIV__"